<template>
    <DocRadioGroupRow
        v-if="item.tpresposta === 'RADIO_GROUP'"
        :item="item"
        :opcoes-grupo="opcoesGrupo"
        :opcoes-ck-obs-grupo="opcoesCkObsGrupo"
        :inside-group="insideGroup"
        @update:item="emit('update:item', $event)"
    />

    <DocItemField
        v-else-if="item.tpresposta === 'FIELD'"
        :item="item"
        :opcoes-api="opcoesApi"
        @update:item="emit('update:item', $event)"
    />

    <DocItemMemo
        v-else-if="item.tpresposta === 'MEMO'"
        :item="item"
        :opcoes-api="opcoesApi"
        @update:item="emit('update:item', $event)"
    />

    <DocItemSelect
        v-else-if="item.tpresposta === 'SELECT'"
        :item="item"
        :opcoes-api="opcoesApi"
        @update:item="emit('update:item', $event)"
    />

    <DocItemCheck
        v-else-if="item.tpresposta === 'CHECK'"
        :item="item"
        :opcoes-api="opcoesApi"
        @update:item="emit('update:item', $event)"
    />

    <DocItemCheckSN
        v-else-if="item.tpresposta === 'CHECK_SN'"
        :item="item"
        @update:item="emit('update:item', $event)"
    />

    <DocItemTable
        v-else-if="item.tpresposta === 'TABELA'"
        :item="item"
    />

    <DocItemUnsupported
        v-else
        :item="item"
    />
</template>

<script setup>
import DocItemField from './DocItemField.vue';
import DocItemMemo from './DocItemMemo.vue';
import DocItemSelect from './DocItemSelect.vue';
import DocItemCheck from './DocItemCheck.vue';
import DocItemCheckSN from './DocItemCheckSN.vue';
import DocItemTable from './DocItemTable.vue';
import DocItemUnsupported from './DocItemUnsupported.vue';
import DocRadioGroupRow from './DocRadioGroupRow.vue';


defineProps({
    item: {
        type: Object,
        required: true
    },
    opcoesGrupo: {
        type: Array,
        default: () => []
    },
    opcoesCkObsGrupo: {
        type: String,
        default: null
    },
    insideGroup: {
        type: Boolean,
        default: false
    },
    opcoesApi: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:item']);
</script>